module.exports = __webpack_public_path__ + "static/media/precise3.9bc87c91.png";